import React, { FC, useState } from 'react'
import Button from '@mui/material/Button'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import { useNavigate } from 'react-router-dom'
import { To } from 'router/To'
import { useAuthRights } from 'ui/hooks/useAuthRights'

const DiagnosticsMenu: FC = () => {
  const { hasFullAccess } = useAuthRights()
  const navigate = useNavigate()
  const [anchor, setAnchor] = useState<HTMLElement | null>(null)

  if (!hasFullAccess) return null

  return (
    <>
      <Button
        color="primary"
        onClick={(event) => setAnchor(event.currentTarget)}
        aria-haspopup="true"
        aria-expanded={Boolean(anchor)}
        sx={{
          color: 'primary.main',
          fontSize: '0.875rem',
          fontWeight: 600,
          minWidth: 'auto',
          px: 1.25,
          textTransform: 'none',
          whiteSpace: 'nowrap',
        }}
      >
        Diagnostics
      </Button>
      <Menu anchorEl={anchor} open={Boolean(anchor)} onClose={() => setAnchor(null)}>
        <MenuItem
          onClick={() => {
            setAnchor(null)
            navigate(To.receiverSimulator)
          }}
        >
          Receiver simulator
        </MenuItem>
      </Menu>
    </>
  )
}

export default DiagnosticsMenu
